/*
 * @fileOverView ThemeToggle component definition
 */

import Vue from 'vue';

/**
 * ThemeToggle component
 *
 * @type {class}
 */
Vue.component('themetoggle-vue', {
  data: function() {
    return {
      theme: false
    }
  },

  watch: {
    theme: {
      /**
       * Sets the component theme on initial load and whenever it is toggled.
       */
      handler: function () {
        // Finds the themeable item. Its base element will have 2 theme-related
        // classes: `theme` and `theme_NAME`. Also, switching is only enabled if
        // there is only one item (more would mean it's a page preview).
        const items = document.querySelectorAll('.theme');
        const item = (items.length === 1) && !items[0].classList.contains('theme_static') ? items[0] : false;
        if (!item) {
          return;
        }

        let classes = item.getAttribute('class').split(' ');

        classes.forEach((c, i) => {
          // Find the class that dictates the current theme.
          let matches = c.match(/^(theme_)(.*)/);

          if (matches) {
            // Sets the theme variable from that class on the initial run.
            if (!this.theme) {
              this.theme = matches[2];
            }

            // Replace the existing theme class with the new value.
            classes[i] = `theme_${this.theme}`;
            item.className = classes.join(' ');
          }
        });
      },
      immediate: true
    }
  }
});
